import { ScannerException } from './ScannerException'; // Import your base exception class
export enum ErrorCode {
  GENERIC,
  PULLTRIGGER,
  RELEASETRIGGER,
}
export class ScannerOperationException extends ScannerException {
  private static errorCodeMessages: Record<number, string> = {
    [ErrorCode.GENERIC]: 'Generic operation error in scanner.',
    [ErrorCode.PULLTRIGGER]: 'Could not pull trigger for scanner.',
    [ErrorCode.RELEASETRIGGER]: 'Could not release trigger for scanner.',
  };

  public code: number;

  constructor(errorCode: number = ErrorCode.GENERIC) {
    const errorMessage = ScannerOperationException.errorCodeMessages[errorCode];
    super(errorMessage);
    this.code = errorCode;
  }
}
